"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SimplifiedCustomDatePickerWidget = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var React = require("react");
var react_datepicker_1 = require("react-datepicker");
var en_GB_1 = require("date-fns/locale/en-GB");
require("react-datepicker/src/stylesheets/datepicker.scss");
var moment = require("moment");
var journey_model_1 = require("@athena-portal/journey-model");
var journey_services_1 = require("@athena-portal/journey-services");
var FalconQuestionWidgetBase_1 = require("./FalconQuestionWidgetBase");
var RenderUtils_1 = require("./utils/RenderUtils");
var SimplifiedCustomDatePickerWidget = /** @class */ (function (_super) {
    __extends(SimplifiedCustomDatePickerWidget, _super);
    function SimplifiedCustomDatePickerWidget(props) {
        var _this = _super.call(this, props) || this;
        _this.bindToField = function (date) {
            var dateMoment = moment(date, moment.ISO_8601);
            var formattedDate = dateMoment.format("YYYY-MM-DD");
            if (dateMoment.isValid()) {
                _this.props.onStateChange(_this.props.question.interactionField, formattedDate);
                _this.changelogRecorder.recordQuestion("change", _this.props);
            }
            _this.validateInternal(formattedDate);
        };
        _this.handleChange = function (date) {
            _this.setState({ date: date, dateClicked: true });
        };
        _this.setDate = function () {
            if (_this.state.date) {
                _this.bindToField(_this.state.date);
                _this.calendarRef.current.setOpen(false);
                _this.executeEvent("change");
            }
        };
        _this.monthsToShow = function () {
            return moment(_this.maxDate).startOf("month").diff(moment(_this.minDate).startOf("month"), "months") + 1;
        };
        _this.state = {
            date: null,
            latestUpcomingMtaStartDate: null,
            dateClicked: false
        };
        (0, react_datepicker_1.registerLocale)("enGB", en_GB_1.default);
        _this.minDateExpression = _this.getSetting("minDateExpression", undefined);
        _this.maxDateExpression = _this.getSetting("maxDateExpression", undefined);
        _this.footerHtml = _this.getSetting("footerHtml", undefined);
        if (_this.minDateExpression) {
            var evaluatedDate = moment(moment.utc(journey_services_1.ExpressionEvaluator.evaluateExpression(_this.minDateExpression, _this.props.interaction, new Date()), moment.ISO_8601).format("YYYY-MM-DD"));
            _this.minDate = evaluatedDate.isAfter(moment()) ? evaluatedDate.toDate() : new Date();
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget is unable to obtain 'minDateExpression'"));
        }
        if (_this.maxDateExpression) {
            _this.maxDate = moment(moment.utc(journey_services_1.ExpressionEvaluator.evaluateExpression(_this.maxDateExpression, _this.props.interaction, moment(30, "d").toDate()), moment.ISO_8601).format("YYYY-MM-DD")).toDate();
        }
        else {
            throw Error("".concat(_this.props.question.type, " widget is unable to obtain 'maxDateExpression'"));
        }
        _this.calendarRef = React.createRef();
        return _this;
    }
    SimplifiedCustomDatePickerWidget.prototype.renderInputField = function () {
        var _this = this;
        var DateInput = function (_a) {
            var value = _a.value, onClick = _a.onClick;
            return ((0, jsx_runtime_1.jsx)("div", { className: "datePickerSelect row", children: (0, jsx_runtime_1.jsxs)("div", { onClick: onClick, onKeyPress: onClick, className: "col-md-12", children: [(0, jsx_runtime_1.jsx)("input", { onClick: _this.executeNativeEvent, type: "radio", name: "date", value: "calendar", id: "datePickerCalendar", role: "dialog", checked: !!_this.state.date }), (0, jsx_runtime_1.jsxs)("label", { htmlFor: "datePickerCalendar", tabIndex: 0, "aria-label": "Choose date from calendar", children: [_this.state.date ? value : "Please select date", (0, jsx_runtime_1.jsx)("span", { className: _this.state.date ? "calendar-icon-selected" : "calendar-icon" }), (0, jsx_runtime_1.jsx)("span", { className: "calendar-arrow-icon" })] })] }) }));
        };
        return ((0, jsx_runtime_1.jsx)("div", { className: "w-100", children: (0, jsx_runtime_1.jsxs)(react_datepicker_1.default, { ref: this.calendarRef, onChange: this.handleChange, selected: this.state.date, customInput: (0, jsx_runtime_1.jsx)(DateInput, {}), locale: "enGB", dateFormat: "dd MMM yyyy", minDate: this.minDate, maxDate: this.maxDate, dayClassName: this.dayClassName, showPreviousMonths: false, showDisabledMonthNavigation: false, disabledKeyboardNavigation: true, shouldCloseOnSelect: false, monthsShown: this.monthsToShow(), showPopperArrow: false, withPortal: true, children: [(0, jsx_runtime_1.jsx)("div", { className: "react-datepicker__footer", children: (0, RenderUtils_1.renderHtml)(this.footerHtml, this.props.interaction) }), (0, jsx_runtime_1.jsx)("div", { className: "d-flex justify-content-center mr-5 ml-5", children: this.renderSelectDateButton() })] }) }));
    };
    SimplifiedCustomDatePickerWidget.prototype.renderSelectDateButton = function () {
        return ((0, jsx_runtime_1.jsxs)("button", { type: "button", className: "btn btn-primary btn-next-arrow-separate", onClick: this.setDate, id: "set-date", disabled: !this.state.date, children: ["Select date", (0, jsx_runtime_1.jsx)("img", { className: "arrow-next", alt: "", src: "/img/arrow-next.png" })] }));
    };
    SimplifiedCustomDatePickerWidget = __decorate([
        (0, journey_model_1.settings)([
            { name: "footerHtml", type: journey_model_1.TypeDescriptions.String },
            { name: "minDateExpression", type: journey_model_1.TypeDescriptions.String },
            { name: "maxDateExpression", type: journey_model_1.TypeDescriptions.String },
            { name: "nextButtonName", type: journey_model_1.TypeDescriptions.String }
        ]),
        __metadata("design:paramtypes", [Object])
    ], SimplifiedCustomDatePickerWidget);
    return SimplifiedCustomDatePickerWidget;
}(FalconQuestionWidgetBase_1.FalconQuestionWidgetBase));
exports.SimplifiedCustomDatePickerWidget = SimplifiedCustomDatePickerWidget;
//# sourceMappingURL=SimplifiedCustomDatePickerWidget.js.map